import { useContext } from 'react';
import { AOIContext } from '../../Contexts/AOIContext';
import { Link } from 'react-router-dom';
import SortIcon from '../../Assets/img/icon-sort.svg';
import ClearIcon from '../../Assets/img/icon-clear.svg';
import AddAOIIcon from '../../Assets/img/icon-plus-cirlce.png';

const AOIHeader = (props) => {
    const { view, hasAOICreatePermission } = useContext(AOIContext);

    return (
        <div className='tabs-switch-section my-aois-container'>
            <div className='container'>
                <div className='tabs-switch'>
                    {
                        view != "map" &&
                        <div className="sort-by">
                            <div className="sorting-ddl">
                                <label>
                                    <img src={SortIcon} />
                                </label>
                                <select className="form-select" onChange={(e) => props.changeSortBy(e.target.value)} value={props.sortBy}>
                                    <option value="lastModifiedDate">Date</option>
                                    <option value="name">Name</option>
                                </select>
                            </div>
                        </div>
                    }
                    {
                        view != "group" &&
                        <div className="aoi-search">
                            <input className="search" id="search" type="search" name="query" placeholder="Enter AOI name" required data-form-type=""
                                value={props.filter.filterText} onChange={(e) => props.setFilter("filterText", e.target.value)} />
                            <i className="clear" onClick={() => { props.setFilter("filterText", "") }}>
                                <img src={ClearIcon} />
                            </i>
                        </div>
                    }
                    <ul className='aoi-header-actions'>
                        {
                            hasAOICreatePermission &&
                            <li>
                                <a onClick={()=>props.setShowAOIUploadModal(true)}>
                                    <img src={AddAOIIcon} className='add-aoi-icon'/> <span>Upload AOI(s)</span>
                                </a>
                            </li>
                        }
                    </ul>
                    <ul className='view-toggle'>
                        <li className={`grid-view ${view == 'list' && 'active'}`}>
                            <Link to={"/portfolio/list"} >
                                <i></i> <span>List</span>
                            </Link>
                        </li>
                        <li className={`map-view ${view == 'map' && 'active'}`}>
                            <Link to={"/portfolio/map"} >
                                <i></i> <span>Map</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default AOIHeader;